<mat-icon [ngClass]="iconClass || 'cb-grey'">{{ icon }}</mat-icon>
<span class="message mat-body-2 flex">{{ message }}</span>
